module.exports = __webpack_public_path__ + "static/img/animales_14.0d7d2056.jpg";